import { joinHendelseIds } from 'features/hendelsekontroll/logg/utils';
import {
  FetchResponseError,
  addMessageToExsistingFetchError,
} from 'utils/errors/customError';
import { buildPath, httpGet } from 'utils/http';

import {
  GetHendelselogg,
  GetHendelseloggDetaljer,
  GetHendelseloggForDeltaker,
  HendelseloggService,
} from './interface';

const basePath = 'hendelser';

const getHendelselogg: GetHendelselogg = async (params, signal?) => {
  const fullPath = buildPath(`${basePath}?${params}`);

  try {
    return httpGet(fullPath, signal).catch((error: FetchResponseError) => {
      throw error;
    });
  } catch (error) {
    const err = error as FetchResponseError;
    throw addMessageToExsistingFetchError(
      err,
      'klarte ikke hente resultater fra server.'
    );
  }
};

const getHendelseloggDetaljer: GetHendelseloggDetaljer = async (
  hendelseIds,
  signal?
) => {
  const hendelseIdsString = joinHendelseIds(hendelseIds);
  const fullPath = buildPath(`${basePath}/detaljer?ids=${hendelseIdsString}`);

  try {
    return httpGet(fullPath, signal).catch((error: FetchResponseError) => {
      throw error;
    });
  } catch (error) {
    const err = error as FetchResponseError;
    throw addMessageToExsistingFetchError(
      err,
      'klarte ikke hente detaljer for hendelse.'
    );
  }
};

const getHendelseloggForDeltaker: GetHendelseloggForDeltaker = async (
  deltakerId,
  signal?
) => {
  const fullPath = buildPath(`${basePath}/${deltakerId}`);

  try {
    return httpGet(fullPath, signal).catch((error: FetchResponseError) => {
      throw error;
    });
  } catch (error) {
    const err = error as FetchResponseError;
    throw addMessageToExsistingFetchError(
      err,
      'klarte ikke hente resultater fra server.'
    );
  }
};

export default {
  getHendelselogg,
  getHendelseloggDetaljer,
  getHendelseloggForDeltaker,
} as HendelseloggService;
